import { TableDependentsComponent } from '../../components/table-dependents/table-dependents.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
	standalone: true,
	selector: 'card-dependents',
	templateUrl: './card-dependents.component.html',
	imports: [ CommonModule, TableDependentsComponent, ListPagerComponent, FormsModule ]
})
export class CardDependentsComponent implements OnInit {
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.dependents = [];
		this.vm.pageSize = 10;
	}

	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
}